import React from "react";
import { useTranslation } from "react-i18next";
import { ExitButtonView } from "../buttons/ExitButtonView";
import "./modalStyles.css";
export var IdlePromptModal = function (_a) {
    var onYes = _a.onYes, onNo = _a.onNo;
    var t = useTranslation().t;
    return (React.createElement("div", { className: "large-modal" },
        React.createElement("p", { className: "info-text" }, t("idle.text")),
        React.createElement("div", null,
            React.createElement(ExitButtonView, { onClose: onYes, onExit: onNo, closeLabel: t("modal.yes"), exitLabel: t("idle.no") }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/modals/IdlePromptModal.tsx
// module id = 199
// module chunks = 1